import useClient from '@hooks/useClient';
import { PieChart, Pie, Cell } from 'recharts';
import { Text } from '@atoms/index';
import { getNumberAsCurrency } from '@helpers/miscelleanous';
import texts from '@components/Calculators/en.json';
import { getPieChartFallback } from '@components/Calculators/helpers';
import { getFdPieChartData } from '@components/Calculators/fd/helper';

const CalculatedResults = ({ calculatedValue, disclaimer = null }) => {
    const { isClient } = useClient();

    const data = getFdPieChartData(calculatedValue);
    const allZero = data.every((entry) => entry.value === 0);
    const pieChartObject = allZero ? getPieChartFallback() : data;

    return (
        <div className="flex flex-col items-center gap-5 w-full">
            {isClient ? (
                <PieChart width={160} height={160}>
                    <Pie
                        data={pieChartObject}
                        cx="50%"
                        cy="50%"
                        outerRadius={80}
                        innerRadius={60}
                        fill="#8884d8"
                        dataKey={null}
                        stroke="none"
                        style={{ outline: 'none' }}
                        startAngle={-270}
                        endAngle={90}
                    >
                        {data.map((entity, index) => (
                            <Cell key={`cell-${index}`} fill={entity.color} />
                        ))}
                    </Pie>
                </PieChart>
            ) : null}
            <div className="flex flex-col gap-3 w-full">
                {data.map((entity, index) => {
                    return (
                        <div key={index} className="flex gap-2 justify-between items-center">
                            <div className="flex items-center gap-2">
                                <div
                                    className={`w-4 h-4 rounded-sm`}
                                    style={{ backgroundColor: entity.color }}
                                />
                                <Text
                                    content={entity.name}
                                    className="text-gray-900 p5-regular"
                                />
                            </div>
                            <Text
                                content={getNumberAsCurrency(
                                    Math.round(entity.value)
                                )}
                                className="text-gray-900 p5-regular"
                            />
                        </div>
                    );
                })}
                <div className="border-b border-dashed border-gray-300" />
                <div className="flex gap-2 justify-between items-center">
                    <Text
                        content={texts?.TotalAmount}
                        className="text-gray-900 p5-regular"
                    />
                    <Text
                        content={getNumberAsCurrency(
                            Math.round(calculatedValue.totalAmount)
                        )}
                        className="text-gray-900 p5-regular"
                    />
                </div>
                {disclaimer ? (
                    <Text
                        content={disclaimer}
                        className="text-gray-500 p6-regular"
                    />
                ): null}
            </div>
        </div>
    );
};

export default CalculatedResults;
